@if (ssvc.settings.schedule.enable_due_time) {
  <div class="form-row">
    <label>
      {{ Yii.t('app', 'Enable Overdue Notifications') }}
    </label>
    <div>
      <label>
        <p-checkbox
          binary="true"
          [(ngModel)]="ssvc.settings.overdue.is_enabled"
        />
        <span class="lbl"></span>
      </label>
    </div>
  </div>
}

@if (ssvc.settings.schedule.enable_due_time && ssvc.settings.overdue.is_enabled) {
  <div class="form-row flex-align-center">
    <label>
      {{ Yii.t('app', 'Overdue') }}
    </label>
    <div>
      <input
        pInputText [value]="dueTimeString" readonly
        style="width: 60px"
        (click)="overduePopover.toggle($event)"
      />
      <p-popover #overduePopover>
        <ng-time-picker
          [(ngModel)]="ssvc.settings.overdue.overdue"
          format="HH:mm:ss"
          [minute-step]="15"
          [showPeriod]="false"
          (timeChange)="syncDueTime()"
        />
      </p-popover>
    </div>
  </div>

  <div class="form-row flex-align-center">
    <label>
      {{ Yii.t('app', 'Recipients') }}
    </label>
    <div>
      @if (ssvc.settings.overdue.subscribers) {
        <ng-select
          [(ngModel)]="assigned_recipients"
          [items]="users"
          [multiple]="true"
          bindLabel="full_name"
          [hideSelected]="true"
          [closeOnSelect]="false"
          [clearable]="false"
          [searchable]="false"
          [placeholder]="Yii.t('app', 'Select recipients')"
        />
      }
    </div>
  </div>
}
